import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React, {ReactNode} from 'react';

import {LEGACY_FONT_PROXIMA_13} from 'styles/FontConstants';
import getTestProps from 'test/lib/cypress/getTestProps';
import Tooltip, {TooltipProps} from 'ui-library/bs/Tooltip';
import {GRAY_LIGHTER} from 'ui-library/Colors';

export const EDIT_VALUE_TOOLTIP_TITLE = 'Edit value';

interface ParameterPillPartTooltipWrapperProps {
  className?: string;
  children: ReactNode;
  tooltipProps: Omit<TooltipProps, 'children'>;
}

export function ParameterPillPartTooltipWrapper(props: ParameterPillPartTooltipWrapperProps): JSX.Element {
  return (
    <Tooltip disabled={false} {...props.tooltipProps}>
      {/*
        Wrap in span so tooltip correctly displays. The tooltip won't display if the children is just a string
        like config.systemName.
      */}
      <span className={props.className}>{props.children}</span>
    </Tooltip>
  );
}

export interface ParameterPillProps {
  onClickConfig?: () => void;
  onClickValue?: () => void;
  renderedConfig: ReactNode;
  renderedValue: ReactNode;
}

export default function ParameterPill(props: ParameterPillProps): JSX.Element {
  const {onClickConfig, onClickValue} = props;
  return (
    <span className={css(styles.pill)} {...getTestProps({component: 'ParameterPill', element: 'root'})}>
      <span
        className={classNames(
          'u-mini-spacing-right u-gray-darker',
          onClickConfig == null ? 'u-cursor-default' : 'u-primary-pointer'
        )}
        onClick={
          onClickConfig == null
            ? undefined
            : () => {
                onClickConfig();
              }
        }
        {...getTestProps({component: 'ParameterPill', element: 'config'})}
      >
        {props.renderedConfig}
      </span>
      <span
        className={onClickValue == null ? 'u-cursor-default' : 'u-pointer'}
        onClick={
          onClickValue == null
            ? undefined
            : () => {
                onClickValue();
              }
        }
        {...getTestProps({component: 'ParameterPill', element: 'value'})}
      >
        {props.renderedValue}
      </span>
    </span>
  );
}

const styles = StyleSheet.create({
  pill: {
    ...LEGACY_FONT_PROXIMA_13,
    backgroundColor: GRAY_LIGHTER,
    borderRadius: 15,
    display: 'inline-flex',
    alignItems: 'center',
    fontWeight: 600,
    marginRight: 10,
    padding: '6px 12px',
  },
});
